import {
  ADD_CAMPAIGN_OFFER_TYPES,
  DELETE_CAMPAIGN_OFFER_TYPES,
  GET_CAMPAIGN_OFFER_TYPE_PROFILE,
  GET_CAMPAIGN_OFFER_TYPES_LIST,
  HIDE_CAMPAIGN_OFFER_TYPES_LOADER,
  SET_CAMPAIGN_OFFER_TYPE_PROFILE,
  SET_CAMPAIGN_OFFER_TYPES_LIST,
  SET_ERROR_CAMPAIGN_OFFER_TYPE_PROFILE,
  SHOW_CAMPAIGN_OFFER_TYPES_LOADER,
  UPDATE_CAMPAIGN_OFFER_TYPE_PROFILE
} from "./actionTypes";

export const getCampaignOfferTypesList = data => ({
  type: GET_CAMPAIGN_OFFER_TYPES_LIST,
  payload: data
})

export const setCampaignOfferTypesList = payload => ({
  type: SET_CAMPAIGN_OFFER_TYPES_LIST,
  payload
})

export const showCampaignOfferTypesListLoader = () => ({
  type: SHOW_CAMPAIGN_OFFER_TYPES_LOADER
})

export const hideCampaignOfferTypesListLoader = () => ({
  type: HIDE_CAMPAIGN_OFFER_TYPES_LOADER
})

export const addCampaignOfferType = (offerType = {}, data = {}) => ({
  type: ADD_CAMPAIGN_OFFER_TYPES,
  payload: { offerType, data }
});

export const deleteCampaignOfferType = (id, data = {}) => ({
  type: DELETE_CAMPAIGN_OFFER_TYPES,
  payload: { id, data }
});

export const getCampaignOfferTypeProfile = id => ({
  type: GET_CAMPAIGN_OFFER_TYPE_PROFILE,
  payload: id
});

export const setCampaignOfferTypeProfile = payload => ({
  type: SET_CAMPAIGN_OFFER_TYPE_PROFILE,
  payload
});

export const updateCampaignOfferTypeProfile = (id, offerType = {}, data = {}) => ({
  type: UPDATE_CAMPAIGN_OFFER_TYPE_PROFILE,
  payload: {id, offerType, data }
});

export const setErrorCampaignOfferTypeProfile = payload => ({
  type: SET_ERROR_CAMPAIGN_OFFER_TYPE_PROFILE,
  payload
});